const topics = [
  { name: '热血战斗', count: '3,280部', hot: true },
  { name: '恋爱日常', count: '2,150部', hot: true },
  { name: '悬疑推理', count: '1,860部', hot: false },
  { name: '奇幻异世界', count: '2,740部', hot: true },
  { name: '搞笑喜剧', count: '1,520部', hot: false },
  { name: '科幻未来', count: '980部', hot: false },
  { name: '恐怖灵异', count: '760部', hot: false },
  { name: '运动竞技', count: '640部', hot: false },
  { name: '美食生活', count: '430部', hot: false },
  { name: '历史古风', count: '890部', hot: false },
  { name: '百合耽美', count: '1,120部', hot: false },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          热门话题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">探索你最爱的漫画类型</p>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <div
              key={i}
              className={`relative flex items-center gap-3 px-5 py-3 rounded-xl cursor-pointer transition-all duration-200 hover:scale-105 ${
                topic.hot
                  ? 'bg-primary-50 border border-primary-200'
                  : 'bg-background-50 border border-background-200 hover:border-primary-200'
              }`}
            >
              <span className={`font-semibold text-sm whitespace-nowrap ${
                topic.hot ? 'text-primary-700' : 'text-foreground-700'
              }`}>
                {topic.name}
              </span>
              <span className={`text-xs whitespace-nowrap ${
                topic.hot ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {topic.count}
              </span>
              {topic.hot && (
                <span className="absolute -top-1.5 -right-1.5 px-1.5 py-0.5 bg-accent-500 text-[9px] font-bold text-background-50 rounded-full whitespace-nowrap">
                  热门
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}